import React from 'react'

import { TermsLinkComponent } from '../types'
import { TermsModalTriggerLink } from './TermsModalTriggerLink'

export const TermsOfSaleLink: TermsLinkComponent = ({
  className,
  setCurrentlyOpenTermsModal,
  text,
}) => (
  <TermsModalTriggerLink
    className={className}
    modalType="termsOfSale"
    setCurrentlyOpenTermsModal={setCurrentlyOpenTermsModal}
  >
    {text}
  </TermsModalTriggerLink>
)

TermsOfSaleLink.defaultProps = {
  className: '',
  text: 'Terms of Sale',
}
